<template>
  <div class="donator_thankyou">
    <div class="container">
   	<div class="row">
   		<div class="col-md-12">
      <h3>Bedankt voor uw bijdrage!</h3>
      <h1>Wordt online collectant!</h1>
      <p>Omdat wij een kleinschallige organisatie zijn, collecteren wij niet langs de deur. Maar we zoeken altijd collectanten om online collectes te lopen! Voel je vrij om voor ons binnen uw netwerk te collecteren!</p>
      <p>
      	<button>Facebook</button>
      	<button>Twitter</button>
      	<button>Google+</button>
      </p>
      <p>Bezoek onze website voor meer informatie over de stichting:</p>
      <a href="http://schisisonderzoek.loc" class="button">schisisonderzoek.nl</a>
    </div>
   </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Donate_thankyou'
}
</script>



// WEBPACK FOOTER //
// src/components/donate/Thankyou.vue